
export default {

  isLarge: true,
  isRetina: false,
  scrollFx: true,
  virtualScroll: true,
  showModal: false,
  currentRoute: window.location.pathname

}



// WEBPACK FOOTER //
// ./src/lib/store.js